<template>
  <div class="pointer__wrapper">
    <div
      class="pointer apollo"
      ref="pointer"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        :viewBox="`0 0 ${circle.cx * 2} ${circle.cy * 2}`"
      >
        <transition-group tag="g" name="fade">
          <circle
            :r="3"
            :cx="circle.cx"
            :cy="circle.cy"
            ref="circle"
            class="circle--sm"
            key="circle"
            v-if="gallery === null"
          />
          <line
            x1="40.9" y1="50" x2="59.1" y2="50"
            key="close"
            v-if="gallery === 'close'"
            fill="none" stroke="#FFFFFF"
          />
          <polyline
            key="prev"
            v-if="gallery === 'prev'"
            points="53.2,56.5 46.8,50 53.2,43.5"
            fill="none" stroke="#FFFFFF"
          />
          <polyline
            key="next"
            v-if="gallery === 'next'"
            points="46.8,43.5 53.2,50 46.8,56.5"
            fill="none" stroke="#FFFFFF"
          />
        </transition-group>
      </svg>
    </div>

    <div
      class="pointer__lg"
      :style="{ transform: `translate3d(${coordsLg.x}px, ${coordsLg.y}px, 0)` }"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        :viewBox="`0 0 ${circle.cx * 2} ${circle.cy * 2}`"
      >
        <circle
          :r="circle.r"
          :cx="circle.cx"
          :cy="circle.cy"
          ref="circleLg"
          class="circle--lg"
        />
      </svg>
    </div>

    <div
      class="interactive__wrapper"
      :style="{ transform: `translate3d(${coordsImage.x}px, ${coordsImage.y}px, 0)` }"
    >
      <transition @enter="enter" @leave="leave" mode="out-in">
        <img
          class="interactive"
          :src="src"
          :key="src"
          style="opacity: 0;"
        >
      </transition>
    </div>
  </div>
</template>

<script>
import { TweenMax, Expo } from 'gsap/TweenMax';
import { mapGetters } from 'vuex';

import apollo from '@/scripts/apollo';

export default {
  name: 'Pointer',

  data() {
    return {
      anim: false,
      scale: 1,

      coords: {
        x: window.innerWidth / 2,
        y: window.innerHeight / 2,
      },

      coordsImage: {
        x: window.innerWidth / 2,
        y: window.innerHeight / 2,
      },

      coordsLg: {
        x: window.innerWidth / 2,
        y: window.innerHeight / 2,
      },

      circle: {
        r: 49,
        cx: 50,
        cy: 50,
        top: 0,
        left: 0,
      },

      src: null,
      gallery: null,
    };
  },

  computed: {
    ...mapGetters({
      init: 'getInit',
    }),
  },


  mounted() {
    apollo.init();

    window.addEventListener('apollo-update', this.currentPosition);
    window.addEventListener('apollo-enter', this.hoverEnter);
    window.addEventListener('apollo-leave', this.hoverLeave);

    this.$eventHub.$on('gallery-close', () => { this.changeCursor(null); });
  },

  methods: {
    currentPosition(event) {
      TweenMax.killTweensOf(this.coordsImage);
      TweenMax.killTweensOf(this.coordsLg);
      TweenMax.to(this.coordsImage, 0.5, {
        x: event.detail.x,
        y: event.detail.y,
        ease: Expo.easeOut,
      });
      TweenMax.to(this.coordsLg, 0.4, {
        x: event.detail.x,
        y: event.detail.y,
        ease: Expo.easeOut,
      });
    },

    hoverEnter(event) {
      if (this.$store.state.menu) return;
      if (event.detail.target.id === 'apollo-interactive') {
        this.src = event.detail.domElement.dataset.img;
      }

      if (event.detail.target.id === 'apollo-gallery') {
        // eslint-disable-next-line
        const type = event.detail.domElement.classList.contains('close') ? 'close' :
          event.detail.domElement.classList.contains('next') ? 'next'
            : 'prev';
        this.changeCursor(type);
      }
    },

    hoverLeave(event) {
      if (event.detail.target.id === 'apollo-interactive') this.src = null;
    },

    enter(el, done) {
      TweenMax.to(el, 0.2, {
        autoAlpha: 1,
        onComplete: done,
      });
    },

    leave(el, done) {
      TweenMax.to(el, 0.2, {
        autoAlpha: 0,
        onComplete: done,
      });
    },

    changeCursor(type) {
      this.gallery = type;
    },
  },
};
</script>

<style lang="scss" scoped>
.pointer {
  position: absolute;
  width: 100px;
  height: 100px;

  z-index: 4;

  svg {
    // fill: none;
    .circle--sm {
      fill: rgba($color-text, 1);
      transition: all 0.2s ease-out;
    }
  }

  &.apollo__cursor--active {
    svg {
      .circle--sm {
        fill: RGB($color-text);
      }
    }

    & + .pointer__lg {
      .circle--lg {
        r: 30;
        fill: none;
        stroke: rgba($color-text, 0.25);
      }
    }
  }

  &__lg {
    pointer-events: none;
    position: absolute;
    width: 100px;
    height: 100px;

    .circle--lg {
      fill: none;
      stroke-width: 1px;
      stroke: rgba($color-text, 0.2);

      transition: all 0.2s ease-out;
    }
  }

  &__wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    z-index: 10;
    pointer-events: none;


    &[data-page="manifesto"] {
      z-index: -1;
      mix-blend-mode: multiply;

      /* @media (prefers-color-scheme: light) {
        mix-blend-mode: unset;
        opacity: 0.7;
      } */
    }


    @include mq($and: $is-touch-device) {
      display: none;
    }
  }
}

.interactive {
  position: relative;
  transform: translate3d(-50%, -50%, 0);

  max-width: 50vw;
  max-height: 50vh;


  &__wrapper {
    position: absolute;
    z-index: -1;
  }
}

.fade-enter-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
